import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { IAssetStocks } from "../types";

export const ASSETS_STOCKS_MODULE_NAME = "assetStocks";

export const assetStocksApiSlice = createApi({
  reducerPath: "assetStocks",
  tagTypes: ["AssetStocks"],
  baseQuery,
  endpoints: (builder) => ({
    fetchAllStocks: builder.query<IAssetStocks[], string>({
      query: (farmId) => ({
        url: "AssetStocks",
        params: { farmId },
      }),
    }),
  }),
});

export const { useFetchAllStocksQuery } = assetStocksApiSlice;
